import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreLiveQuery, firestoreQuery } from '../firebase';
import { MessageData } from '../types';
import { createCrudActions } from '../utils/redux';

let cancelLiveMessages: any;

interface ChatsState {
  messages: MessageData[];
  messagesLoading: boolean;
  loadingMore: boolean;
  cursor: any;
}

const initialState: ChatsState = {
  messages: [],
  messagesLoading: false,
  loadingMore: false,
  cursor: null,
}


const messageActions = createCrudActions<MessageData, ChatsState>({
  idKey: 'id',
  itemsKey: 'messages',
  sort: {
    field: 'createTime',
    order: 'desc',
  }
});


const service = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    setMessagesLoading(state, action: PayloadAction<boolean>): ChatsState {
      return { ...state, messagesLoading: action.payload, }
    },
    setLoadingMore(state, action: PayloadAction<boolean>): ChatsState {
      return { ...state, loadingMore: action.payload, }
    },
    setCursor(state, action: PayloadAction<any>): ChatsState {
      return { ...state, cursor: action.payload, }
    },
    resetMessages(state): ChatsState {
      return { ...state, messages: [], messagesLoading: false, }
    },

    onMessageAdd: messageActions.onAdd,
    onMessageAddMany: messageActions.onAddMany,
    onMessageUpdate: messageActions.onUpdate,
    onMessageDelete: messageActions.onDelete,
  }
});


const resetMessages = (): AppThunk => async (dispatch, getState) => {
  cancelLiveMessages && cancelLiveMessages();
  dispatch(service.actions.resetMessages());
}

const loadMessages = (type?: string): AppThunk => async (dispatch, getState) => {
  dispatch(resetMessages());
  dispatch(service.actions.setMessagesLoading(true));

  let query = firestore
    .collectionGroup('chat_messages')
    .where('supportChat', '==', false)
    .orderBy('createTime', 'desc')
    .limit(50);

  if (type && type !== 'all') {
    query = query.where('type', '==', type);
  }

  cancelLiveMessages = firestoreLiveQuery<MessageData>({
    query,
    onAdd: (item) => {
      dispatch(service.actions.onMessageAdd(item));
    },
    onUpdate: (item) => {
      dispatch(service.actions.onMessageUpdate(item));
    },
    onDelete: (item) => {
      dispatch(service.actions.onMessageDelete(item));
    },
    onInitial: (items, cursor) => {

      dispatch(service.actions.setCursor(cursor));
      dispatch(service.actions.onMessageAddMany(items));
      dispatch(service.actions.setMessagesLoading(false));
    },
    skipInitialOnAdd: true,
  })
}

const loadMoreMessages = (type?: string): AppThunk => async (dispatch, getState) => {

  const state = getState();

  if (!state.chats.cursor || state.chats.loadingMore) {
    return;
  }

  dispatch(service.actions.setLoadingMore(true));

  let query = firestore
    .collectionGroup('chat_messages')
    .where('supportChat', '==', false)
    .orderBy('createTime', 'desc')
    .startAfter(state.chats.cursor)
    .limit(50);

  if (type && type !== 'all') {
    query = query.where('type', '==', type);
  }

  const result = await firestoreQuery<MessageData>(query);

  dispatch(service.actions.onMessageAddMany(result.list));
  dispatch(service.actions.setCursor(result.lastItem));
  dispatch(service.actions.setLoadingMore(false));
}



export const actions = {
  resetMessages,
  loadMessages,
  loadMoreMessages,
}

export default service.reducer;